import CustomComponent from "../../components/customComponent";
import { withToast } from "../../App";
import hoistStatics from "hoist-non-react-statics";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../components/withRouter";
import { BoaterLayout } from "../../components/Layouts";
import { withBoaterStorage } from "../../hooks/useBoaterStorage";
import Dropdown from "../../components/Dropdown";
import { StepNavigation } from "../../components/StepNavigation";

class BoaterProcess extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            waterPrice: "XX,XX",
            electricityPrice: "XX,XX",
            minAmount: "XXX",
            maxAmount: "XXX",
            maxDuration: "X",
            currentYear: new Date().getFullYear(),
        };
    }

    componentDidMount() {
        this.checkIsConnectedPWA();
        this.fetchPriceGroup();
    }

    fetchPriceGroup = async () => {
        const response = await this.request("/price-group/default", "GET");
        if (response && response.status === "ok") {
            const priceGroup = response.price_group;
            if (priceGroup) {
                const waterPrice = priceGroup.m3Price
                    ? priceGroup.m3Price
                    : "XX,XX";

                const electricityPrice = priceGroup.kwhPrice
                    ? priceGroup.kwhPrice
                    : "XX,XX";

                const minAmount = priceGroup.minAmount
                    ? priceGroup.minAmount
                    : "XXX";

                const maxAmount = priceGroup.maxAmount
                    ? priceGroup.maxAmount
                    : "XXX";

                const maxDuration = priceGroup.maxDurationHours
                    ? priceGroup.maxDurationHours / 24
                    : "X";

                this.setState({
                    waterPrice,
                    electricityPrice,
                    minAmount,
                    maxAmount,
                    maxDuration,
                });
            }
        }
    };

    nextStep = () => {
        // Clear boaterProcess localStorage to reset procedure
        this.props.clearBoaterStorage();
        this.props.history.push("/boater/step1");
    };

    render() {
        const { t } = this.props;
        const {
            waterPrice,
            electricityPrice,
            minAmount,
            maxAmount,
            maxDuration,
            currentYear,
        } = this.state;

        return (
            <BoaterLayout step={0}>
                <div className="boater__step-container">
                    <div className="dropdown-container">
                        <Dropdown buttonText={`${t("tariffs")} ${currentYear}`}>
                            <div className="tariffs-content">
                                <p className="tariffs-section">
                                    {t("tariffs_unit_price")}
                                </p>
                                <p className="tariffs-item">
                                    {t("tariffs_cubic_meter") +
                                        " : " +
                                        waterPrice +
                                        " €"}
                                </p>
                                <p className="tariffs-item">
                                    {t("tariffs_kilowatt_hour") +
                                        " : " +
                                        electricityPrice +
                                        " €"}
                                </p>

                                <p className="tariffs-section">
                                    {t("tariffs_payment_method")}
                                </p>
                                <p className="tariffs-item">
                                    {t("tariffs_min_amount") +
                                        " : " +
                                        minAmount +
                                        " €"}
                                </p>
                                <p className="tariffs-item">
                                    {t("tariffs_max_amount") +
                                        " : " +
                                        maxAmount +
                                        " €"}
                                </p>

                                <p className="tariffs-section">
                                    {t("tariffs_duration")}
                                </p>
                                <p className="tariffs-item">
                                    {maxDuration + "j maximum"}
                                </p>
                            </div>
                        </Dropdown>
                    </div>
                    <StepNavigation
                        nextHandler={this.nextStep}
                        nextLabel={t("boater_step1_cta")}
                        nextTitle={t("boater_step1_cta")}
                    />
                </div>
            </BoaterLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(withBoaterStorage(BoaterProcess))),
        BoaterProcess,
    ),
);
